import React from 'react';
import { Linkedin, Github } from 'lucide-react';
interface Props {
  onNavigateImprint?: () => void;
  onNavigatePrivacy?: () => void;
}
export function Footer({
  onNavigateImprint,
  onNavigatePrivacy
}: Props) {
  return <footer className="bg-[#020611] border-t border-border py-12" data-id="element-186">
      <div className="container mx-auto px-6" data-id="element-187">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8" data-id="element-188">
          <div data-id="element-189">
            <img src="https://cdn.magicpatterns.com/uploads/hEdhox844qFVGVrfYybLur/291EA45A-1FD8-43AC-AA88-9205857BA77E.jpg" alt="PEZULA AI" className="h-6" data-id="element-190" />
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-muted" data-id="element-191">
            <button onClick={onNavigateImprint} className="hover:text-accent transition-colors" data-id="element-192">
              Impressum
            </button>
            <button onClick={onNavigatePrivacy} className="hover:text-accent transition-colors" data-id="element-193">
              Datenschutz
            </button>
            <a href="#blog" className="hover:text-accent transition-colors" data-id="element-194">
              Blog
            </a>
            <a href="#kontakt" className="hover:text-accent transition-colors" data-id="element-195">
              Kontakt
            </a>
          </div>

          <div className="flex items-center gap-4" data-id="element-196">
            <a href="#" className="text-muted hover:text-accent transition-colors" aria-label="LinkedIn" data-id="element-197">
              <Linkedin size={20} data-id="element-198" />
            </a>
            <a href="#" className="text-muted hover:text-accent transition-colors" aria-label="GitHub" data-id="element-199">
              <Github size={20} data-id="element-200" />
            </a>
          </div>
        </div>

        <div className="text-center text-xs text-muted-dark border-t border-border/50 pt-8" data-id="element-201">
          © 2026 PEZULA Projects and Experts GmbH. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>;
}